import styled from "styled-components"

const AccesDirectItemDescription = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

export { AccesDirectItemDescription }
